import watchDashboardTransactions from './getDashboardTransactions';

export default [
  watchDashboardTransactions(),
];
